/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 21:45:41
 * @LastEditTime: 2024-11-11 15:16:13
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* 写在前面
 * 用户信息相关的都是后端url上拼接，不需要再和App交互
 * 对于设置标题等等别的交互，用的都是4.2.0中的新的交互
 */

import Vue from 'vue'
import App from './App'
import router from './router'
import storage from 'storejs'
import { createUuid, getUrlParam } from './../src/utils/common'
import store from './store'
import system from './utils/checkSystem.js'
import { Lazyload, Toast, InfiniteScroll, Picker } from 'mint-ui'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import {
  setNavTitleColor_old,
  setTitleColor_old
} from './../src/utils/JSbridge'
import FormulaCommonComponent from './../src/components/formulaComponent/formulaInput.js'
import VConsole from 'vconsole'

import { Popover } from 'element-ui'

// 神策埋点 start
import sa from 'sa-sdk-javascript'
import './utils/manulTrack' // 通过自定义指令实现给动态dom添加手动埋点监听的功能

// 引入图片懒加载
import VueLazyload from 'vue-lazyload'

import ScratchCard from 'vue-scratch-card0'
// import Vant from 'vant';
// import 'vant/lib/index.css';
window.uuid = createUuid()
Vue.use(FormulaCommonComponent)

Vue.component(Popover.name, Popover)
Vue.use(ScratchCard)

Vue.config.productionTip = false
Vue.use(Lazyload)
Vue.use(InfiniteScroll)
Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载的宽高比
  error: 'https://studioyszimg.yxj.org.cn/1586314469505.png', // 图片加载失败时使用的图片源
  loading: 'https://studioyszimg.yxj.org.cn/1586314469505.png', // 图片加载的路径
  attempt: 1, // 尝试加载次数
  ListenEvents: ['scroll']
})

Vue.component(Picker.name, Picker)

// if (process.env.ENV_CONFIG !== 'prod') new VConsole()

// 兼容es6
require('es6-promise').polyfill()
Es6Promise.polyfill()
// 公共的弹窗样式
Vue.prototype.toast = function (msg, type) {
  if (type) {
    if (type === 'success') {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-wancheng'
      })
      return window.toastName
    } else if (type === 'error') {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-huabanfuben'
      })
      return window.toastName
    } else {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-huabanfuben'
      })
      return window.toastName
    }
  } else {
    window.toastName = Toast({
      message: msg,
      position: 'middle',
      className: 'toasts'
      // iconClass: 'icon iconfont icon-huabanfuben'
    })
    return window.toastName
  }
}
let getEnvObj = process.env
window.appId = getEnvObj.appId
window.API_ROOT = getEnvObj.API_ROOT // 生产地址
window.API_ROOT_YSZ = getEnvObj.API_ROOT_YSZ // 生产地址
window.API_ROOT_NEW = getEnvObj.API_ROOT_NEW
window.saUrl = getEnvObj.saUrl
window.web_Url = document.location.protocol + getEnvObj.web_Url
window.wakeAppUrl = getEnvObj.wakeAppUrl // 跳转App链接

// 本地开发调试注入
if (getEnvObj.ENV_CONFIG !== 'prod') {
  new VConsole()
} else {
  setTimeout(() => {
    if (router.app._route.query.uid == '17317554822') {
      new VConsole()
    }
  }, 3000)
}

/** 神策初始化 */
sa.init({
  server_url: window.saUrl,
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'default',
    is_single_page: true
  },
  app_js_bridge: true,
  show_log: false
})
sa.registerPage({
  platform: '临床决策助手',
  tool_isAnonymousVisitor: true
})
sa.quick('autoTrack', {
  $screen_name: '公式-公式详情页'
})
store.state.system = system()
store.state.isWeChat = /MicroMessenger/i.test(navigator.userAgent)
router.afterEach((to, from) => {
  console.log('to.name', to)
  store.state.base.currentPageInfoComponent = to.name && to.name.replace(/_/g, '') + 'info'
  console.log('currentPageInfoComponent', store.state.base.currentPageInfoComponent)
  setInterceptBarEvent(true)
  window.scrollTo(0, 0)

  if (to.meta.titleBg) {
    setTitleColor_old(to.meta.titleBg)
    setTitleColor(to.meta.titleBg)
  }
  if (to.meta.titleColor) {
    setNavTitleColor_old(to.meta.titleColor)
    setNavTitleColor(to.meta.titleColor)
  }
  if (to.meta.title) {
    let title = to.meta.title.replace(/<[^>]+>/g, '')
    document.title = title
  }

  // sa.quick('autoTrackSinglePage', {
  //   $screen_name: to.meta.title
  // })
})
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js